<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h2 class="mt-5">Dashboard</h2>
            </v-col>
        </v-row>
        <v-row v-if="user.admin">
            <v-col md="3" cols="12">
                <v-card to="/users" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>Total Users</h3>
                                <h6>All users except admins</h6>
                            </v-col>
                            <v-col cols="12">
                                <h1 >{{ totalUsers }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col md="3" cols="12">
                <v-card to="/users" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>Trial Users</h3>
                                <h6>Closed Positions Only</h6>
                            </v-col>
                            <v-col cols="12">
                                <h1 >{{ trial }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col md="3" cols="12">
                <v-card to="/users" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>Standard Users</h3>
                                <h6>Closed & Open Positions</h6>
                            </v-col>
                            <v-col cols="12">
                                <h1 >{{ standard }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col md="3" cols="12">
                <v-card to="/users" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>Premium Users</h3>
                                <h6>Closed & Open + Premium Positions</h6>
                            </v-col>
                            <v-col cols="12">
                                <h1 >{{ premium }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> 
        <v-divider class="my-5"></v-divider>
        <v-row>
            <v-col md="3" cols="12">
                <v-card to="/positions" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>BUY Positions</h3>
                            </v-col>
                            <v-col cols="12">
                                <h1 >{{ buy }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col md="3" cols="12">
                <v-card to="/positions" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>HOLD Positions</h3>
                            </v-col>
                            <v-col cols="12">
                                <h1>{{ hold }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col md="3" cols="12">
                <v-card to="/closedpositions" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>CLOSE Positions</h3>
                            </v-col>
                            <v-col cols="12">
                                <h1 >{{ close }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-divider class="my-5"></v-divider>
        <v-row>
            <v-col md="3" cols="12">
                <v-card to="/closedpositions" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>CLOSE with Positive Returns</h3>
                            </v-col>
                            <v-col cols="12">
                                <h1>{{ closePositive }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col md="3" cols="12">
                <v-card to="/closedpositions" elevation="5">
                    <v-card-text>
                        <v-row align-content="center" justify="center">
                            <v-col cols="12">
                                <h3>CLOSE with Negative Returns</h3>
                            </v-col>
                            <v-col cols="12">
                                <h1>{{ closeNegative }}</h1>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { supabase } from '../supabase';
export default {
    data:() => ({
        users: [],
        positions: [],
        totalUsers: 0,
        trial: 0,
        standard: 0,
        premium: 0,
        buy: 0,
        hold: 0,
        close: 0,
        closePositive: 0,
        closeNegative: 0
    }),

    methods: {
        async getUsers() {
            const { data, error } = await supabase
                .from('users')
                .select('package')
                .eq('admin', false)
                .eq('deleted', false)
            if (error) {
                console.error('Error fetching positions:', error);
            } else {
                this.users = data;
                this.totalUsers = data.length;
                // Count users with package === 'TRIAL'
                this.trial = data.filter(user => user.package === 'TRIAL').length;
                this.standard = data.filter(user => user.package === 'STANDARD').length;
                this.premium = data.filter(user => user.package === 'PREMIUM').length;
            }
        },

        async getPositions () {
            const { data, error } = await supabase
                .from('positions')
                .select('current_view, returns')
                .order('entry_date', { ascending: false })
                
            if (error) {
                console.error('Error fetching positions:', error);
            } else {
                this.positions = data;
                this.buy = data.filter(position => position.current_view === 'BUY').length
                this.hold = data.filter(position => position.current_view === 'HOLD').length
                this.close = data.filter(position => position.current_view === 'CLOSE').length
                this.closePositive = data.filter(position => position.current_view === 'CLOSE' && position.returns > 0).length
                this.closeNegative = data.filter(position => position.current_view === 'CLOSE' && position.returns <= 0).length
            }
        }
    },

    computed: {
        user () {
            return this.$store.getters.loadedUser
        }
    },
    mounted() {
        if(this.users.length == 0) {
            this.getUsers()
        }
        if(this.positions.length == 0) {
            this.getPositions()
        }

    },

    
}
</script>